import React from 'react';

import { EuiFlexGrid, EuiFlexItem } from '../../../../src/components';

export default () => (
  <EuiFlexGrid columns={3}>
    <EuiFlexItem>One</EuiFlexItem>
    <EuiFlexItem>Two</EuiFlexItem>
    <EuiFlexItem>Three</EuiFlexItem>
    <EuiFlexItem>Four</EuiFlexItem>
    <EuiFlexItem>Five</EuiFlexItem>
    <EuiFlexItem>Six</EuiFlexItem>
    <EuiFlexItem>Seven</EuiFlexItem>
  </EuiFlexGrid>
);
